"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CONTEXT_DATA_EVENT", {
  enumerable: true,
  get: function () {
    return _contextData.Name;
  }
});
var _contextData = require("@ori-events/context-data");
